__webpack_require__.p = "https://bmidxbsouthafricaplprod.netlify.app/";